// Import modules
import { store, persistor } from './store';

window.store = store;

// Export modules
export { store, persistor };
